import infoImg from "@images/general/info.png";

import {useEffect, useRef, useState} from "react";

import {SmallDesc} from "@ui/descriptions/SmallDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import {useTranslation} from "react-i18next";

import {getEvaluationToolTooltip} from "./criteriaGridHelpers";
import styles from "../styles.module.scss";

export const EvaluationToolInfo = ({tool}) => {
  const {t} = useTranslation();
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(false);

  const tooltip = getEvaluationToolTooltip(tool, t);
  const isVisible = Boolean(tooltip) && (open || hovered);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => document.removeEventListener("click", handleClickOutside);
  }, [open]);

  if (!tooltip) {
    return null;
  }

  return (
    <div
      ref={rootRef}
      className={styles.evaluationToolInfo}
      data-info-open={isVisible ? "true" : undefined}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <button
        type={"button"}
        className={styles.evaluationToolInfoButton}
        aria-label={"info"}
        onClick={() => setOpen((value) => !value)}
      >
        <img
          src={infoImg}
          alt={"info"}
        />
      </button>

      {isVisible && (
        <div className={styles.evaluationToolInfoBlock}>
          <BorderArticle>
            <div className={styles.evaluationToolInfoContent}>
              <SmallDesc>
                <span dangerouslySetInnerHTML={{__html: tooltip}} />
              </SmallDesc>
            </div>
          </BorderArticle>
        </div>
      )}
    </div>
  );
};
